import { gql } from '@apollo/client';
import {
  CATEGORY_BASIC_WITH_TRANSLATION_FRAGMENT,
  CATEGORY_WITH_NESTED_CHILDREN_FRAGMENT,
  CATEGORY_WITH_NESTED_CHILDREN_SORT_BY_FRAGMENT,
} from '../../fragments/categoryFragments';
import { PRODUCT_BASIC_FRAGMENT } from '../../fragments/productFragments';

export const CATEGORY_LIST_QUERY = gql`
  query CategoryList(
    $first: Int
    $after: String
    $level: Int
    $filter: CategoryFilterInput
    $productFilter: ProductFilterInput
    $languageCode: LanguageCodeEnum!
    $childrenFilter: CategoryFilterInput
    $sortBy: CategorySortingInput
  ) {
    categories(
      first: $first
      after: $after
      level: $level
      filter: $filter
      sortBy: $sortBy
    ) {
      edges {
        node {
          id
          name
          slug
          description
          icon
          level
          isActive
          isInCatalog
          isBottom
          isPopular
          translation(languageCode: $languageCode) {
            name
          }
          products(first: 1, filter: $productFilter) {
            totalCount
          }
          parent {
            id
            name
            slug
            icon
            level
            isActive
            isInCatalog
            isPopular
            isBottom
            products(first: 1, filter: $productFilter) {
              totalCount
            }
          }
          children(first: 100, filter: $childrenFilter) {
            edges {
              node {
                id
                name
                slug
              }
            }
          }
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${CATEGORY_BASIC_WITH_TRANSLATION_FRAGMENT}
`;

// $productSortBy: ProductOrder
// $productChannel: String
// $productBefore: String
// $productAfter: String
// $productFirst: Int
// $productLast: Int

// sortBy: $productSortBy
// channel: $productChannel
// before: $productBefore
// after: $productAfter
// first: $productFirst
// last: $productLast

export const CATEGORY_QUERY = gql`
  query Category(
    $id: ID
    $slug: String
    $slugLanguageCode: LanguageCodeEnum
    $productFilter: ProductFilterInput
    $productWhere: ProductWhereInput
    $first: Int
    $similarProductsFilter: ProductFilterInput
    $languageCode: LanguageCodeEnum!
  ) {
    category(id: $id, slug: $slug, slugLanguageCode: $slugLanguageCode) {
      id
      name
      slug
      description
      icon
      level
      isActive
      isInCatalog
      isBottom
      isPopular
      seoTitle
      metaDescription
      metaKeywords
      translation(languageCode: $languageCode) {
        name
      }
      parent {
        id
        name
        slug
        icon
        level
        isActive
        isInCatalog
        isPopular
        isBottom
      }
      ancestors(first: 10) {
        edges {
          node {
            id
            name
            slug
            level
            translation(languageCode: $languageCode) {
              name
            }
          }
        }
      }
      children(first: $first) {
        edges {
          node {
            id
            name
            slug
            translation(languageCode: $languageCode) {
              name
            }
          }
        }
      }
      products(first: $first, filter: $productFilter, where: $productWhere) {
        edges {
          node {
            ...ProductBasic
            translation(languageCode: $languageCode) {
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
    }
  }
  ${PRODUCT_BASIC_FRAGMENT}
`;

export const CATEGORY_SEO_QUERY = gql`
  query CategorySEO($id: ID, $languageCode: LanguageCodeEnum!) {
    category(id: $id) {
      id
      name
      slug
      description
      icon
      level
      isActive
      isInCatalog
      isBottom
      isPopular
      seoTitle
      metaDescription
      metaKeywords
      translation(languageCode: $languageCode) {
        name
      }
    }
  }
`;

export const CATEGORY_LIST_WITH_NESTED_CHILDREN_QUERY = gql`
  query CategoryListWithNestedChildren(
    $first: Int
    $after: String
    $level: Int
    $filter: CategoryFilterInput
    $languageCode: LanguageCodeEnum!
  ) {
    categories(first: $first, after: $after, level: $level, filter: $filter) {
      edges {
        node {
          ...CategoryWithNestedChildren
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${CATEGORY_WITH_NESTED_CHILDREN_FRAGMENT}
`;

export const CATEGORY_LIST_WITH_NESTED_CHILDREN_SORT_BY_QUERY = gql`
  query CategoryListWithNestedChildrenSortBy(
    $first: Int
    $after: String
    $level: Int
    $filter: CategoryFilterInput
    $productSortBy: ProductOrder
    $languageCode: LanguageCodeEnum!
  ) {
    categories(first: $first, after: $after, level: $level, filter: $filter) {
      edges {
        node {
          ...CategoryWithNestedChildrenSortBy
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${CATEGORY_WITH_NESTED_CHILDREN_SORT_BY_FRAGMENT}
`;
